export default {
  props: {
    data: Object,
    thumbnailWidth: {
      type: Number,
      default: 80
    },
    thumbnailHeight: {
      type: Number,
      default: 80
    },
    multiCol: {
      type: Boolean
    },
    titleStyle: Object
  },
  computed: {
    thumbStyle() {
      const {
        thumbnailWidth,
        thumbnailHeight,
        multiCol
      } = this;
      return multiCol ? {
        width: '100%'
      } : {
        width: `${thumbnailWidth}px`,
        height: `${thumbnailHeight}px`
      };
    },

    bodyStyle() {
      return this.multiCol ? {
        padding: 0
      } : null;
    },

    transformedTitle() {
      return this.data.title ? this.data.title : this.data.TITLE;
    }

  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    }

  }
};